import React, { useEffect, useRef, useState } from "react";
import * as styles from "./CafeteraBotones.module.scss";
import SliderArrowLeft from "../../../icons/arrows/slider-arrow-left.svg";
import SliderArrowRight from "../../../icons/arrows/slider-arrow-right.svg";
import ReusableItemDesc from "../../Products/Etermo/ItemDescription/ItemDescription";
import line1 from "../../../images/line6.svg";
import imgBackgraund from "../../../images/cafeterabg1_2.png";
import imgBackgraund1 from "../../../images/cafeterabg1_3.png";
import imgBackgraund2 from "../../../images/cafeterabg1_4.png";
import imgBackgraund3 from "../../../images/cafeterabg1_5.png";
import imgBackgraund4 from "../../../images/cafeterabg1_6.png";
import imgBackgraund5 from "../../../images/cafeterabg1_7.png";
import { motion } from "framer-motion";

const CafeteraBotones = () => {
  const ref = useRef(null);
  const sectionsRef = useRef([]);
  const [currentSection, setCurrentSection] = useState(0);
  const backgroundImages = [
    imgBackgraund,
    imgBackgraund1,
    imgBackgraund2,
    imgBackgraund3,
    imgBackgraund4,
    imgBackgraund5,
    imgBackgraund5,
  ];

  const back = {
    backgroundColor: "black",
    position: "absolute",
    width: "100%",
    height: "100vh",
    zIndex: -300,
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
  };

  const back2 = {
    backgroundImage: `url(${imgBackgraund})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundColor: "black",
    position: "absolute",
    width: "100%",
    height: "100vh",
    zIndex: -220,
    top: "0",
    left: "0",
    width: "40%",
    height: "100%",
  };

  const getBackgroundStyle = () => {
    let backgroundImage = `url(${
      backgroundImages[currentSection] || backgroundImages[0]
    })`;

    return {
      backgroundImage: backgroundImage,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      backgroundColor: "black",
      position: "absolute",
      width: "100%",
      height: "100vh",
      zIndex: -200,
      top: "0",
      left: "0",
      width: "40%",
      height: "100%",
    };
  };

  const handleScroll = (e) => {
    if (ref.current) {
      const currentScrollLeft = ref.current.scrollLeft;
      const sections = sectionsRef.current;

      const isAtStart = currentScrollLeft === 0;
      const isAtEnd =
        currentScrollLeft + ref.current.offsetWidth >= ref.current.scrollWidth;

      // Si estamos en la primera sección y hacemos scroll hacia arriba, permitir el scroll vertical
      if (isAtStart && e.deltaY < 0) {
        return;
      }

      // Si estamos en la última sección y hacemos scroll hacia abajo, permitir el scroll vertical
      if (isAtEnd && e.deltaY > 0) {
        return;
      }

      // Prevenir el comportamiento predeterminado para manejar el scroll horizontal
      e.preventDefault();

      // Lógica para moverse entre secciones
      let targetSectionIndex = -1;

      if (e.deltaY > 0) {
        targetSectionIndex = sections.findIndex(
          (section) => section.offsetLeft - 1 >= currentScrollLeft
        );
      } else {
        targetSectionIndex = sections.findIndex(
          (section) => section.offsetLeft + 1 >= currentScrollLeft
        );
        if (targetSectionIndex !== -1) {
          targetSectionIndex -= 1;
        }
      }

      if (targetSectionIndex === -1) {
        targetSectionIndex = e.deltaY > 0 ? sections.length - 1 : 0;
      }

      if (targetSectionIndex >= 0 && targetSectionIndex < sections.length) {
        const targetSection = sections[targetSectionIndex];
        ref.current.scrollTo({
          left: targetSection.offsetLeft,
          behavior: "smooth",
        });
      }

      // Actualizar la visibilidad de los botones
      setCurrentSection(targetSectionIndex);
    }
  };

  useEffect(() => {
    const ulElement = ref.current;

    if (ulElement) {
      ulElement.addEventListener("wheel", handleScroll, { passive: false });
    }

    return () => {
      if (ulElement) {
        ulElement.removeEventListener("wheel", handleScroll);
      }
    };
  }, []);

  const goToNextSection = () => {
    const currentScrollLeft = ref.current.scrollLeft;
    const sections = sectionsRef.current;
    const nextSectionIndex = sections.findIndex(
      (section) => section.offsetLeft > currentScrollLeft
    );
    if (nextSectionIndex !== -1) {
      ref.current.scrollTo({
        left: sections[nextSectionIndex].offsetLeft,
        behavior: "smooth",
      });

      setCurrentSection(nextSectionIndex);
    }

    const isLastSection = nextSectionIndex >= sections.length - 1;

    // Mostrar siempre el botón Anterior al avanzar
  };

  const goToPreviousSection = () => {
    const currentScrollLeft = ref.current.scrollLeft;
    const sections = sectionsRef.current;

    // Buscamos la sección actualmente en foco
    const currentSectionIndex = sections.findIndex(
      (section, index) =>
        currentScrollLeft >= section.offsetLeft &&
        (index === sections.length - 1 ||
          currentScrollLeft < sections[index + 1].offsetLeft)
    );

    // Determinamos si hay una sección anterior
    const previousSectionIndex =
      currentSectionIndex > 0 ? currentSectionIndex - 1 : -1;

    if (previousSectionIndex !== -1) {
      ref.current.scrollTo({
        left: sections[previousSectionIndex].offsetLeft,
        behavior: "smooth",
      });

      setCurrentSection(previousSectionIndex);
    }

    const isFirstSection = previousSectionIndex <= 0;
  };

  return (
    <section className={styles.container_section}>
         <div ref={ref} style={getBackgroundStyle()} />
      <div ref={ref} style={back2} />
      <div style={back} />

      {currentSection !== 0 && (
        <button onClick={goToPreviousSection} className={styles.previousButton}>
          <img src={SliderArrowLeft} alt="boton izquierda" />
        </button>
      )}

      {currentSection !== 6 && (
        <button onClick={goToNextSection} className={styles.nextButton}>
          <img src={SliderArrowRight} alt="boton derecha" />
        </button>
      )}

      <div className={styles.container_img}>
        {/* PRIMERA SECCION */}

        {(currentSection === 0 || currentSection === 1) && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: currentSection === 1 ? 0.3 : 1 }}
            transition={{ duration: 1 }}
            className={styles.img_item}
          >
            <div className={styles.Line}>
              <img src={line1} alt="line1" />
            </div>

            <ReusableItemDesc
              title="Pulse 1 veces"
              description="Café espresso simple
              40 - 60 ml."
              textColor="white"
            />
          </motion.div>
        )}

        {/*     SEGUNDA SECCION */}

        {currentSection === 1 && (
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className={styles.img_item2}
          >
            <div className={styles.Line}>
              <img src={line1} alt="line1" />
            </div>

            <ReusableItemDesc
              title="Pulse 2 veces"
              description="Café espresso doble
              90 - 110 ml."
              textColor="white"
            />
          </motion.div>
        )}

        {/*  TERCERA SECCION */}

        {(currentSection === 2 || currentSection === 3) && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: currentSection === 3 ? 0.3 : 1 }}
            transition={{ duration: 1 }}
            className={`${styles.img_item} ${styles.postion_section2}`}
          >
            <div className={styles.Line}>
              <img src={line1} alt="line1" />
            </div>

            <ReusableItemDesc
              title="Pulse 1 veces"
              description="Capuccino chico
              80 - 150 ml.
              
              "
              textColor="white"
            />
          </motion.div>
        )}

        {/*  CUARTA SECCION */}

        {currentSection === 3 && (
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className={`${styles.img_item2} ${styles.postion_section2}`}
          >
            <div className={styles.Line}>
              <img src={line1} alt="line1" />
            </div>

            <ReusableItemDesc
              title="Pulse 2 veces"
              description="Capuccino grande
            160 - 300 ml.
            "
              textColor="white"
            />
          </motion.div>
        )}

        {(currentSection === 4 ||
          currentSection === 5 ||
          currentSection === 6) && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{
              opacity: currentSection === 5 || currentSection === 6 ? 0.3 : 1,
            }}
            transition={{ duration: 1 }}
            className={`${styles.img_item} ${styles.postion_section3}`}
          >
            <div className={styles.Line}>
              <img src={line1} alt="line1" />
            </div>

            <ReusableItemDesc
              title="Pulse 1 veces"
              description="Capuccino chico
              80 - 150 ml.
              
              "
              textColor="white"
            />
          </motion.div>
        )}

        {(currentSection === 5 || currentSection === 6) && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{
              opacity: currentSection === 6 ? 0.3 : 1,
            }}
            className={`${styles.img_item2} ${styles.postion_section3}`}
          >
            <div className={styles.Line}>
              <img src={line1} alt="line1" />
            </div>

            <ReusableItemDesc
              title="Pulse 2 veces"
              description="Capuccino grande
            160 - 300 ml.
            "
              textColor="white"
            />
          </motion.div>
        )}

        {currentSection === 6 && (
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className={`${styles.img_item3} ${styles.postion_section3} ${styles.postion_section4}`}
          >
            <div className={styles.Line}>
              <img src={line1} alt="line1" />
            </div>
            <ReusableItemDesc
              title="Pulse 3 veces"
              description="Leche de
              forma manual
            "
              textColor="white"
            />
          </motion.div>
        )}
      </div>

      <ul ref={ref}>
        <li ref={(el) => (sectionsRef.current[0] = el)}>
          <section className={styles.container_section}>
            <div className={styles.container_inf}></div>
          </section>
        </li>
        <li ref={(el) => (sectionsRef.current[1] = el)}>
          <section className={styles.container_section}></section>
        </li>

        <li ref={(el) => (sectionsRef.current[2] = el)}>
          <section className={styles.container_section}></section>
        </li>

        <li ref={(el) => (sectionsRef.current[3] = el)}>
          <section className={styles.container_section}></section>
        </li>

        <li ref={(el) => (sectionsRef.current[4] = el)}>
          <section className={styles.container_section}></section>
        </li>

        <li ref={(el) => (sectionsRef.current[5] = el)}>
          <section className={styles.container_section}></section>
        </li>

        <li ref={(el) => (sectionsRef.current[6] = el)}>
          <section className={styles.container_section}></section>
        </li>
      </ul>
    </section>
  );
};

export default CafeteraBotones;
